var chunkMapping = {
	"129": [
		64129
	],
	"189": [
		95189
	],
	"253": [
		83253
	],
	"380": [
		71380
	],
	"385": [
		77385
	],
	"401": [
		39401
	],
	"428": [
		67428
	],
	"625": [
		72625
	],
	"781": [
		49781
	],
	"823": [
		52823
	],
	"839": [
		85839
	]
};
var idToExternalAndNameMapping = {
	"39401": [
		"default",
		"./BreadcrumbSeperator",
		33692
	],
	"49781": [
		"default",
		"./NoDataFound",
		33692
	],
	"52823": [
		"default",
		"./LoadMore",
		33692
	],
	"64129": [
		"default",
		"./CaseList",
		38443
	],
	"67428": [
		"default",
		"./ConfirmationBox",
		33692
	],
	"71380": [
		"default",
		"./Filter",
		33692
	],
	"72625": [
		"default",
		"./AddCase",
		38443
	],
	"77385": [
		"default",
		"./CaseDetails",
		38443
	],
	"83253": [
		"default",
		"./TruncatedText",
		33692
	],
	"85839": [
		"default",
		"./CardDetails",
		33692
	],
	"95189": [
		"default",
		"./TrainingsList",
		70555
	]
};
__webpack_require__.f.remotes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = function(error) {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = function() {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = function(fn, arg1, arg2, d, next, first) {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then(function(result) { return next(result, d); }, onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = function(external, _, first) { return external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError(); };
			var onInitialized = function(_, external, first) { return handleFunction(external.get, data[1], getScope, 0, onFactory, first); };
			var onFactory = function(factory) {
				data.p = 1;
				__webpack_require__.m[id] = function(module) {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}